import { useMutation, useQueryClient } from 'react-query';
import {
  performanceReportingApiUrl,
  fetcher,
  handleError,
  ServerErrorResponse,
} from 'data_sources/constants';
import type { EisRuleConfigurationRule, SaveEisRuleConfigurationRequest } from '../_types';

export const saveEisRuleConfiguration = async (
  ruleId: number,
  data: SaveEisRuleConfigurationRequest,
  onError?: (errors: ServerErrorResponse) => void
): Promise<EisRuleConfigurationRule> => {
  const url = `${performanceReportingApiUrl()}/performance/eis/v1/rules/${ruleId}/configuration`;
  return fetcher({
    url,
    method: 'PUT',
    body: data,
  })
    .then((response) => {
      if (response?.errorDetails) {
        if (onError) onError(response);
      }
      return response as EisRuleConfigurationRule;
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
      throw err;
    });
};

export default function useSaveEisRuleConfiguration() {
  const queryClient = useQueryClient();
  return useMutation(
    ({ ruleId, data }: { ruleId: number; data: SaveEisRuleConfigurationRequest }) =>
      saveEisRuleConfiguration(ruleId, data),
    {
      onSuccess: (_, { ruleId }) => {
        queryClient.invalidateQueries(['eisRuleConfiguration', ruleId]);
        queryClient.invalidateQueries(['eisRule', ruleId]);
        queryClient.invalidateQueries(['eisRules']);
      },
    }
  );
}
